module.exports = __webpack_public_path__ + "static/media/i6.9254e920.svg";